import { createContext } from "react";
import type { SearchAllOutput } from "../../../utils/trpc";

type SearchContextType = {
  setSearchQuery: (query: string) => void;
  results?: SearchAllOutput;
  searchQuery?: string;
  isLoading?: boolean;
  isFetched?: boolean;
  fetchStatus?: "idle" | "fetching" | "fetchMore" | "stale" | "paused";
  selectedPublications?: { id: number | string; title: string }[];
  setSelectedPublications: (
    publications: { id: number | string; title: string }[],
  ) => void;
  relatedSearches: string[];
};

export const SearchContext = createContext<SearchContextType>(
  {} as SearchContextType,
);
